import { STYLE_OPTIONS } from 'src/constants';

const pageViewStyle = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),

    '&.shadows-v1': {
      boxShadow: theme.shadows[1],
    },
  },

  relativeBox: {
    position: 'relative',
    minHeight: 150,
  },

  buttonBack: {
    ...STYLE_OPTIONS.BUTTON_EMPTY_STYLE,
    marginTop: -4,
    '&:hover svg': STYLE_OPTIONS.SVG_COLOR_BLUE,
  },
});

export default pageViewStyle;
